import React, { useState, useEffect, useCallback } from 'react';
import accessLogsService from '../../../services/accessLogsService';
import TimelineView from './TimelineView';
import FilterPanel from './FilterPanel';

const UserActivityTimelineTab = ({ darkMode }) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState('');
  const [filters, setFilters] = useState({
    page: 1,
    pageSize: 50
  });

  const loadData = useCallback(async () => {
    if (!selectedUserId) {
      setLogs([]);
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      setError(null);
      const logsData = await accessLogsService.getUserTimeline(selectedUserId, filters);
      setLogs(logsData.logs || []);
    } catch (err) {
      setError(err.message || 'Failed to load user timeline');
      setLogs([]);
    } finally {
      setLoading(false);
    }
  }, [selectedUserId, filters]);

  useEffect(() => {
    if (selectedUserId) {
      loadData();
    } else {
      setLogs([]);
      setError(null);
    }
  }, [selectedUserId, filters, loadData]);

  useEffect(() => {
    const handleRefresh = () => {
      if (selectedUserId) loadData();
    };
    window.addEventListener('accessLogsRefresh', handleRefresh);
    return () => window.removeEventListener('accessLogsRefresh', handleRefresh);
  }, [selectedUserId, loadData]);

  const handleFilterChange = (newFilters) => {
    setFilters({ ...filters, ...newFilters, page: 1 });
  };

  return (
    <div className={`access-logs-tab-content ${darkMode ? 'dark-mode' : ''}`}>
      <div className="user-selector">
        <label>
          Select User:
          <input
            type="text"
            value={selectedUserId}
            onChange={(e) => setSelectedUserId(e.target.value)}
            placeholder="Enter user ID or email"
            style={{ marginLeft: '8px', padding: '8px', width: '300px' }}
          />
        </label>
      </div>
      {selectedUserId && (
        <>
          <FilterPanel filters={filters} onChange={handleFilterChange} darkMode={darkMode} />
          {error && (
            <div className="error-message">
              {error}
              <button onClick={loadData}>Retry</button>
            </div>
          )}
          <TimelineView logs={logs} loading={loading} darkMode={darkMode} />
        </>
      )}
      {!selectedUserId && (
        <div className="empty-state">
          Please select a user to view their activity timeline.
        </div>
      )}
    </div>
  );
};

export default UserActivityTimelineTab;

